export const contactFormatter = (contacts) => {
    // Find the template row (where values are literal "name", "email", "date")
    const templateRow = contacts.find(contact =>
        Object.values(contact.data).includes("name") &&
        Object.values(contact.data).includes("email") &&
        Object.values(contact.data).includes("date")
    );
    
    if (!templateRow) return [];

    const nameColId = Object.keys(templateRow.data).find(key => templateRow.data[key] === "name");
    const emailColId = Object.keys(templateRow.data).find(key => templateRow.data[key] === "email");
    const dateColId = Object.keys(templateRow.data).find(key => templateRow.data[key] === "date");
    
    // Find phone column by looking for the remaining column that's not name, email, or date
    const phoneColId = Object.keys(templateRow.data).find(key => 
        key !== nameColId && 
        key !== emailColId && 
        key !== dateColId
    );

    // Helper function to format phone number
    const formatPhoneNumber = (phone) => {
        if (!phone) return null;
        
        // Convert to string and remove any non-digit characters
        const phoneStr = phone.toString().replace(/\D/g, '');
        
        // Format based on length (assuming Nigerian format for your example)
        if (phoneStr.length === 10) {
            // Format as: 0803 723 9519
            return phoneStr.replace(/(\d{4})(\d{3})(\d{4})/, '$1 $2 $3');
        } else if (phoneStr.length === 11 && phoneStr.startsWith('0')) {
            // Format as: 0803 723 9519
            return phoneStr.replace(/(\d{4})(\d{3})(\d{4})/, '$1 $2 $3');
        } else if (phoneStr.length === 13 && phoneStr.startsWith('234')) {
            // Format international: +234 803 723 9519
            return phoneStr.replace(/(\d{3})(\d{3})(\d{3})(\d{4})/, '+$1 $2 $3 $4');
        }
        
        // Return as-is if format doesn't match expected patterns
        return phoneStr;
    };

    // Filter out template rows and format the rest
    return contacts
        .filter(contact => {
            // Check if this is the template row by comparing key values
            return !(
                contact.data[nameColId] === "name" && 
                contact.data[emailColId] === "email" &&
                contact.data[dateColId] === "date"
            );
        })
        .map(contact => ({
            id: contact.id,
            name: contact.data[nameColId] || "",
            email: contact.data[emailColId] || "",
            phone_no: formatPhoneNumber(phoneColId ? contact.data[phoneColId] : null),
            date: contact.data[dateColId] || "",
            position: contact.position,
        }));
}